let currentScrollTop = 0;
let previousScrollTop = 0;
let isScrollingUp = false;

const handleWindowScroll = () => {
  currentScrollTop = window.scrollY;
  isScrollingUp = currentScrollTop <= previousScrollTop;
  previousScrollTop = currentScrollTop;
};

window.addEventListener('scroll', () => {
  handleWindowScroll();
});

const setupComponentScrollTrigger = (componentElement, timeline, start = 'top bottom', end = 'bottom top') => {
  ScrollTrigger.create({
    scroller: document.documentElement,
    trigger: componentElement,
    start,
    end,
    onEnter: () => timeline.play(),
  });
};